import axios from 'axios';

const SidebarApi = {
  getUserListings: async (token, userId) => {
    try {
      const response = await axios.get(
        `${process.env.API_URL}/api/v1.0/user/my-listings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  getUserSales: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/order/sales/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  getUserOrders: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/order/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  getUserWishLists: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/listing/wishlist/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  getUserTickets: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/ticket/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  getUserMessages: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/chat/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  getUserAddresses: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/user/address`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
};

export default SidebarApi;
